<div class="right-pane d-flex" [class.chat-dock-open]="isDockOpen">
  <div
    class="right-pane__content flex-grow-1 min-width-0 d-flex flex-column"
    [style.marginRight]="isDockOpen && dockWidth && isDesktopLayout ? dockWidth + 'px' : null"
  >
    @if (this.maintenanceData?.isMarquee && !isMaintenanceInfoAcknowledged) {
      <div class="adv-maintenance">
        <span>{{maintenanceData?.marqueeMsg}}</span>
        <img
          class="cross-icon d-block cursor-pointer"
          fetchpriority="high"
          width="24"
          height="24"
          src="images/cross-white.svg"
          alt="Close"
          (click)="isMaintenanceInfoAcknowledged = true"
        />
      </div>
    }
    <router-outlet></router-outlet>
  </div>

  @if (isDockOpen && !isLoadingPage) {
    <app-chat-dock class="chat-dock-host"></app-chat-dock>
  }
</div>

@if (isDockOpen && !isLoadingPage) {
  <div class="chat-dock-backdrop d-lg-none" (click)="closeDock()"></div>
}

@if (!isLoadingPage) {
  <app-chat-entry-bar></app-chat-entry-bar>
}

<app-loader></app-loader>
